import React from 'react';
import { Card, Spinner, EmptyState, AlertCircle } from '@opendate-app/setlist';

export default function ReachabilityCard({ insights, insightsError }) {
  const reachability = insights && insights.reachability ? insights.reachability : [];

  return (
    <Card padding="md">
      <h2 style={{ margin: '0 0 12px', fontSize: 18 }}>Can you reach them</h2>
      {insightsError ? (
        <EmptyState
          size="sm"
          icon={AlertCircle}
          title="Couldn't load reachability"
          description="Refresh the page to try again."
        />
      ) : !insights ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <Spinner label="Loading…" />
        </div>
      ) : reachability.length === 0 ? (
        <EmptyState size="sm" title="No reachability data yet" />
      ) : (
        reachability.map((row) => (
          <div key={row.key} style={{ padding: '8px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 4 }}>
              <span style={{ fontWeight: 600 }}>{row.label}</span>
              <span style={{ color: 'var(--sl-text-quaternary, #717680)' }}>{row.value}%</span>
            </div>
            <div style={{ height: 6, borderRadius: 3, background: 'var(--sl-bg-secondary, #f2f4f7)' }}>
              <div
                style={{
                  height: '100%',
                  borderRadius: 3,
                  background: 'var(--sl-fg-brand)',
                  width: `${Math.min(row.value, 100)}%`,
                }}
              />
            </div>
          </div>
        ))
      )}
    </Card>
  );
}
